import React, { Component } from 'react';
import {http} from '../misc/http';
import Layout from '../layout/Auth';
import sun from '../assets/sun.png';

export default class Login extends Component {
  state={
    formReset: {
      token: '',
      password:'',
      newPassword: '',
    },
    disabled: true
  }
  
  handleVerify = async () => {
    let params = {
      method:'POST',
      path:'auth/resetPassword/verify',
      data:this.state.formReset
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      this.resetForm();
      this.props.history.push('/login')
    }
  }

  getToken = async (token) => {
    let params = {
      method:'GET',
      path:'auth/resetPassword/get/'+token,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      let {formReset} = this.state;
      formReset.token = token
      this.setState({formReset})
    } else {
      alert(data.message)
      this.props.history.push('/forgotPassword')
    }
  }

  validate = () => {
    let {formReset:{token, newPassword, password}, disabled} = this.state;
    if (token !== '' && password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/g) !== null && newPassword === password) disabled = false
    else disabled = true;
    this.setState({disabled})
  }
  
  handleOnChange = async ({target: {name, value}}) => {
    let {formReset} = this.state;
    formReset[name] = value;
    await this.setState({formReset});
    this.validate()
  }

  resetForm = () => {
    let {formReset} = this.state;
    formReset.token = '';
    formReset.password = '';
    formReset.newPassword = '';
    this.setState({formReset})
  }

  componentDidMount = () => {
    let token = this.props.match.params.token;
    this.getToken(token);
  }

  render() {
    return (
      <Layout>
        <div className="card card-primary card-auth" style={{borderRadius: '0px'}}>
          <div className="card-body text-center">
            <p className="mb-4" style={{fontSize: '25px', fontWeight: '600'}}>Silahkan Masukan Password Baru Anda</p><br/>
            <div className="auth" action="">
              <div className="input-group mb-3">
                <div className="input-group-prepend"><span className="input-group-text" id="basic-addon1"><img src={sun} alt="sun" style={{width: '20px',height: '20px'}} /></span></div>
                <input className="form-control" type="password" placeholder="Password" name="password" onChange={(e) => this.handleOnChange(e)}/>
              </div>
              <div className="input-group mb-3">
                <div className="input-group-prepend"><span className="input-group-text" id="basic-addon1"><img src={sun} alt="sun" style={{width: '20px',height: '20px'}} /></span></div>
                <input className="form-control" type="password" placeholder="Ketik Ulang Password" name="newPassword" onChange={(e) => this.handleOnChange(e)}/>
              </div>
              <button className="btn btn-blue w-100 mt-4" style={{padding: '14px 25px !important', background: '#005097'}}     disabled={this.state.disabled} onClick={() => this.handleVerify()}>Kirim</button>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
